"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectEntries = exports.getObjectKeys = exports.isDefinedObject = void 0;
const isDefinedObject = (data) => {
    return data != null && typeof data === 'object';
};
exports.isDefinedObject = isDefinedObject;
const getObjectKeys = (o) => Object.keys(o);
exports.getObjectKeys = getObjectKeys;
const getObjectEntries = (o) => Object.entries(o);
exports.getObjectEntries = getObjectEntries;
//# sourceMappingURL=objectUtils.js.map